import { useCallback, useEffect, useState } from "react";
import arkadu from "src/coreConfig";
import { useSelector } from "src/store";
import axiosInstance from "src/utils/axios";

const buildSupportUrl = (session) => {
  const params = new URLSearchParams({
    token: session.access_token,
    refresh_token: session.refresh_token,
    redirect: session.support_project.chat_url,
    user: JSON.stringify(session.user),
  });
  return `${session.web_url}/#/auth/sso?${params.toString()}`;
};

const useTodooDaySupport = () => {
  const { adminMode } = useSelector((state) => state.settings);
  const { currentCustomer } = useSelector((state) => state.customers);
  const [available, setAvailable] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let active = true;
    setAvailable(false);

    if (!adminMode || !currentCustomer?.id) {
      return () => {
        active = false;
      };
    }

    axiosInstance
      .post(arkadu.urls.v2.customer.todoo_day_support.availability, {
        customer_id: currentCustomer.id,
        mode: "admin",
      })
      .then((response) => {
        if (active) {
          setAvailable(
            response.data?.res === 1 && response.data?.data?.enabled,
          );
        }
      })
      .catch(() => {
        if (active) {
          setAvailable(false);
        }
      });

    return () => {
      active = false;
    };
  }, [adminMode, currentCustomer?.id]);

  const openSupport = useCallback(async () => {
    const supportWindow = window.open(
      "",
      "TodooDaySupport",
      "width=520,height=760",
    );
    setLoading(true);
    try {
      const response = await axiosInstance.post(
        arkadu.urls.v2.customer.todoo_day_support.session,
        {
          customer_id: currentCustomer.id,
          mode: "admin",
        },
      );
      if (response.data?.res !== 1) {
        throw new Error(response.data?.message || "todoo.day support failed");
      }

      const supportUrl = buildSupportUrl(response.data.data);
      if (supportWindow) {
        supportWindow.location.replace(supportUrl);
      } else {
        window.open(supportUrl, "_blank", "noopener,noreferrer");
      }
    } catch (error) {
      supportWindow?.close();
      throw error;
    } finally {
      setLoading(false);
    }
  }, [currentCustomer?.id]);

  return { available, loading, openSupport };
};

export default useTodooDaySupport;
